import React, { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import AOS from 'aos';
import 'aos/dist/aos.css';
import {
  FiUser, FiMail, FiLock, FiEye, FiEyeOff, FiCheck, FiArrowLeft,
  FiCode
} from 'react-icons/fi';
import { useDispatch, useSelector } from 'react-redux';

import Image from "../../../assets/logo.png";
import { Link, useNavigate } from 'react-router-dom';
import usePost from '../../../hooks/api/usePost';
import apiRequest from '../../../utils/apiRequest';
import toast from 'react-hot-toast';
import axios from 'axios';
import { setUserProfile } from '../../../store/slice/globalStore';
import authManager from '../../../utils/authManager';
import { formatValidationError, getFileUrl } from '../../../utils/helper';
import { DASHBOARD_ROUTE, FORGOT_PASSWORD_ROUTE, HOME_ROUTE, MEMBER_DASHBOARD_ROUTE } from '../../../routes/web/rootRoutes';
import { FORM_ROUTE } from '../../../routes/web/rootRoutes';


const LoginSignup = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [isUnionMember, setIsUnionMember] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      easing: 'ease-out-quad'
    });
  }, []);
  const setting = useSelector(
    (state) => state.globalState.siteSetting?.site_settings
  );

  // const forms = useSelector((state) => state.globalState?.siteSetting?.formData);
  // console.log(forms)

  const forms = [
    {
      created_at:"2025-08-28T20:42:55.000000Z",
      description:"<p>NEW MEMBERSHIP APPLICATION COSTUME DEPARTMENT</p>",
      form:"1756453512.pdf",
      header_img:"17608579805167881.png",
      heading:"NEW MEMBERSHIP APPLICATION - CD",
      id:10,
      status:"Active",
      sub_heading:"NEW MEMBERSHIP APPLICATION - CD",
      title:"NEW MEMBERSHIP APPLICATION - CD",
      type:"NEW MEMBERSHIP APPLICATION - CD",
      updated_at:"2025-10-19T01:43:00.000000Z"
    },
    {
      created_at:"2025-08-28T20:42:55.000000Z",
      description:"<p>NEW MEMBERSHIP APPLICATION ART DEPARTMENT</p>",
      form:"1756453878.pdf",
      header_img:"17608579805167881.png",
      heading:"NEW MEMBERSHIP APPLICATION ART DEPARTMENT",
      id:9,
      status:"Active",
      sub_heading:"NEW MEMBERSHIP APPLICATION ART DEPARTMENT",
      title:"NEW MEMBERSHIP APPLICATION ART DEPARTMENT",
      type:"NEW MEMBERSHIP APPLICATION ART DEPARTMENT",
      updated_at:"2025-10-19T01:43:00.000000Z"
    },
  ]


  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const membershipForm = useFormik({
    initialValues: {
      isMember: "yes"
    },
    validationSchema: Yup.object({
      isMember: Yup.string()
        .required('Please select an option')
        .oneOf(['yes', 'no'], 'Invalid selection')
    }),
    onSubmit: values => {
      setIsUnionMember(values.isMember === 'yes');
    }
  });



  const handleApply = (formType) => {
    // console.log(formType)
    navigate(FORM_ROUTE(formType));
  };
  const stripHtml = (html) => {
    if (typeof window === 'undefined') return html || "";
    if (!html) return "";

    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = html;
    return tempDiv.textContent || tempDiv.innerText || "";
  };

  const getFormColor = (type) => {
    const colorMap = {
      'MEDICAL': 'bg-blue-100 text-blue-800 border-blue-200',
      'REGISTRATION': 'bg-purple-500 text-purple-800 border-purple-200',
      'NOMINATION': 'bg-green-100 text-green-800 border-green-200',
      'UPGRADATION': 'bg-amber-100 text-amber-800 border-amber-200',
      'COMPLAINT': 'bg-red-100 text-red-800 border-red-200'
    };

    for (const [key, value] of Object.entries(colorMap)) {
      if (type.includes(key)) return value;
    }

    return 'bg-gray-100 text-gray-800 border-gray-200';
  };

  const getFormIcon = (type) => {
    const iconMap = {
      'MEDICAL': '🏥',
      'REGISTRATION': '📝',
      'NOMINATION': '👥',
      'UPGRADATION': '📈',
      'COMPLAINT': '📢'
    };

    for (const [key, value] of Object.entries(iconMap)) {
      if (type.includes(key)) return value;
    }

    return '📄';
  };


  return (
    <div className="h-[100vh] flex items-center justify-center bg-gradient-to-br from-indigo-50 via-purple-50 to-pink-50 ">
      <div className="w-full h-[100vh] grid grid-cols-1 lg:grid-cols-2 bg-white shadow-2xl overflow-hidden ">
        <div className="relative hidden border-r-2 lg:block" data-aos="fade-right">
          <div className="w-full h-full bg-gray-200 border-0" style={{
            backgroundImage: `url(${Image})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center'
          }}></div>
        </div>

        <div className="p-8 md:p-12 lg:p-16 flex flex-col justify-start overflow-y-auto h-[100vh]" data-aos="fade-left">
          <div className="flex justify-center mb-6">
            <Link to={'/'}>
              <img
                src={getFileUrl(setting?.site_logo, 'setting')}
                alt="logo"
                loading="lazy"
                className="w-20 sm:w-28"
              />
            </Link>
          </div>

          {isUnionMember !== null && (
            <button
              onClick={() => setIsUnionMember(null)}
              className="flex items-center mb-4 font-semibold text-purple-600 transition-colors cursor-pointer hover:text-purple-800"
            >
              <FiArrowLeft className="mr-2" /> Back
            </button>
          )}

          <div className="mb-10 text-center">
            {isUnionMember === null ? (
              <form onSubmit={membershipForm.handleSubmit} className="space-y-6">
                <h2 className="mb-2 text-3xl font-bold text-gray-800">
                  Are you a union member?
                </h2>
                <p className="mb-6 text-gray-600">
                  Please confirm your membership status to continue
                </p>

                <div className="flex flex-col gap-4">
                  <div className="flex flex-col gap-6">
                    <div className="flex items-center justify-center">
                      <div className="flex items-center mr-1">
                        <input
                          id="yes"
                          name="isMember"
                          type="radio"
                          value="yes"
                          
                          className="w-5 h-5 text-purple-600"
                          onChange={membershipForm.handleChange}
                          onBlur={membershipForm.handleBlur}
                        />
                        <label htmlFor="yes" className="block ml-2 text-lg text-gray-700">
                          Yes, I'm a member
                        </label>
                      </div>

                      <div className="flex items-center">
                        <input
                          id="no"
                          name="isMember"
                          type="radio"
                          value="no"
                          className="w-5 h-5 text-purple-600"
                          onChange={membershipForm.handleChange}
                          onBlur={membershipForm.handleBlur}
                        />
                        <label htmlFor="no" className="block ml-2 text-lg text-gray-700">
                          No, I'm not
                        </label>
                      </div>
                    </div>

                    {membershipForm.touched.isMember && membershipForm.errors.isMember && (
                      <p className="mt-1 text-sm text-red-500">
                        {membershipForm.errors.isMember}
                      </p>
                    )}
                  </div>

                  <button
                    type="submit"
                    className="mt-4 cursor-pointer w-full bg-gradient-to-r from-purple-600 to-indigo-700 text-white py-3 rounded-xl font-semibold shadow-lg hover:from-purple-700 hover:to-indigo-800 transition-all transform hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-opacity-50"
                  >
                    Continue
                  </button>
                </div>
              </form>
            ) : isUnionMember ? (
              <LoginForm
                showPassword={showPassword}
                togglePasswordVisibility={togglePasswordVisibility}
              />
            ) : (
              <div className="py-8 text-center">
                {/* <h3 className="mb-4 text-2xl font-bold text-gray-800">Union Membership Required</h3>
                <p className="max-w-md mx-auto mb-6 text-gray-600">
                  Only union members can access this system. If you believe this is an error,
                  please contact your union representative for assistance.
                </p>
                <button
                  onClick={() => setIsUnionMember(null)}
                  className="px-6 py-3 font-medium text-gray-800 transition-colors bg-gray-100 rounded-lg hover:bg-gray-200"
                >
                  Back to Membership Check
                </button> */}

                <div className="py-8 text-center">
  <h3 className="mb-8 text-3xl font-bold text-gray-800">
    To Become a New Member
  </h3>

  <div className="grid max-w-5xl grid-cols-1 gap-8 mx-auto text-left md:grid-cols-2">

    {/* Left Box – Documents */}
    <div className="p-8 bg-white border border-purple-200 shadow-xl rounded-2xl">
      <h4 className="mb-4 text-xl font-semibold text-purple-700">
        Required Documents
      </h4>

      <ul className="pl-5 space-y-3 text-gray-700 list-disc">
        
        <li>Education | Tech. Qualification Degree | Diploma etc.</li>
        <li>Residential | Address Proof : Ration Card | Passport etc. | adhar Card (Any One)</li>
        <li>Photo ID:Pan Card | Driving License etc.(Any One)</li>
        <li>Recent Photographs Nos. (Passport Size)</li>
        <li>Reference letter from 3 Art Direction (must be the members of our Association)
</li><li>Health Certificate.</li>
        
      </ul>
    </div>

    {/* Right Box – Address */}
    <div className="p-8 bg-white border border-indigo-200 shadow-xl rounded-2xl">
      <h4 className="mb-4 text-xl font-semibold text-purple-700">
        Office Address
      </h4>

      <div className="space-y-2 text-gray-700">
        <p>237-238,KUBER COMPLEX, OPP. LAXMI INDUSTRIAL ESTATE, NEW LINK ROAD, ANDHERI- W, MUMBAI – 400053.</p>
      </div>
    </div>

  </div>
</div>



                <div className="grid grid-cols-1 gap-8 mt-8 md:grid-cols-2">
                  {forms?.map((form) => {
                    const formColor = getFormColor('REGISTRATION');
                    const formIcon = getFormIcon(form.type);


                    return (
                      <div
                        key={form.id}
                        className="flex flex-col overflow-hidden transition-all duration-300 transform bg-white border border-purple-200 shadow-lg rounded-2xl hover:shadow-xl hover:-translate-y-1"
                      >
                        <div className={`p-7 border-b ${formColor} flex items-center justify-between`}>
                          {/* <div className="flex items-center">
                            <span className="mr-3 text-2xl">{formIcon}</span>
                            <span className="text-sm font-semibold">{form.type.split(' ')[0]}</span>
                          </div>
                          <span className="inline-flex items-center px-3 py-1 text-xs font-medium bg-white rounded-full bg-opacity-80">
                            {form.status}
                          </span> */}
                        </div>

                        <div className="flex-grow p-6">
                          <div className="flex items-start justify-between mb-4">
                            <h2 className="text-lg font-bold leading-tight text-gray-900">{form.title}</h2>
                            <span className="ml-2 text-xs text-gray-500 whitespace-nowrap">
                              {new Date(form.created_at).toLocaleDateString()}
                            </span>
                          </div>

                          {form.sub_heading && form.sub_heading !== form.title && (
                            <p className="mb-4 text-sm text-gray-600">{form.sub_heading}</p>
                          )}

                          <div className="p-4 mb-2 text-sm text-gray-700 rounded-lg bg-gray-50">
                            {stripHtml(form.description).length > 120
                              ? `${stripHtml(form.description).substring(0, 120)}...`
                              : stripHtml(form.description)
                            }
                          </div>
                        </div>

                        <div className="p-5 border-t border-gray-100 bg-gray-50">
                          <div className="flex flex-col gap-3 sm:flex-row">
                            <button
                              onClick={() => handleApply(form.type)}
                              className="flex items-center justify-center flex-1 px-4 py-3 text-sm font-semibold text-white transition-all duration-300 rounded-lg shadow-md cursor-pointer bg-violet-600 hover:bg-violet-800 hover:shadow-lg"
                            >
                              <span className="mr-2">📋</span>
                              Apply Now
                            </button>
                            <a
                              href={getFileUrl(form?.form, 'form')}
                              target='_blank'
                              className="flex items-center justify-center flex-1 px-4 py-3 text-sm font-medium text-gray-700 transition-all duration-300 border border-gray-300 rounded-lg cursor-pointer hover:bg-zinc-400 hover:text-white"
                            >
                              <span className="mr-2">⬇️</span>
                              Download
                            </a>
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

const LoginForm = ({ showPassword, togglePasswordVisibility }) => {
  const { isLoading, post } = usePost(apiRequest.login);
  const [serverErrors, setServerErrors] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [error, setError] = useState(null);
  const formik = useFormik({
    initialValues: {
      union_code: '',
      password: '',
    },
    validationSchema: Yup.object({
      union_code: Yup.string()
        .required('Union code is required'),
      password: Yup.string()
        .min(5, 'Password must be at least 8 characters')
        .required('Password is required'),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      console.log(values);

      try {
        const response = await axios.post(
          `${process.env.REACT_APP_API_URL}login`,
          values,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          }
        );

        
        if (response.status === 200 && response.data?.access_token) {

          const userData = {
            ...response.data.data,
            ...response.data.member_payment_data,
            
            access_token: response.data.access_token,
            token_type: response.data.token_type,
            expires_in: response.data.expires_in,
          };

          authManager.setAccessToken(response.data.access_token);
          authManager.setUserProfile(userData);

          dispatch(setUserProfile(userData));

          toast.success(`Hi ${response.data?.data?.name}, ${response.data?.msg || 'Login successful'}`);

          setTimeout(() => {
            navigate(DASHBOARD_ROUTE);
          }, 1000);
        } else {
          toast.error(response.data?.msg || 'Login failed');
        }


      } catch (error) {
        if (error.response?.status === 403) {
          return;
        } else if (error.response?.status === 422) {
          const formattedErrors = formatValidationError(error.response.data);
          setServerErrors(formattedErrors?.errors);
          setError(String(formattedErrors?.msg));
          toast.error(String(formattedErrors?.msg));
        } else {
          setServerErrors(null);
          setError(String(error?.response?.data?.message || error));
          toast.error(
            String(error?.response?.data?.message || error.response?.statusText)
          );
        }
      } finally {
        setSubmitting(false);
      }
    },

  });

  return (
    <form onSubmit={formik.handleSubmit} className="space-y-6">
      <div className="mb-6 text-center">
        <h2 className="mb-2 text-3xl font-bold text-gray-800">
          Union Member Login
        </h2>
        <p className="text-gray-600">
          Enter your union credentials to continue
        </p>
      </div>

      <div data-aos="fade-up" data-aos-delay="100">
        <label htmlFor="union_code" className="block mb-2 font-medium text-left text-gray-700">
          Union Code
        </label>
        <div className="relative text-left">
          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
            <FiCode className="text-gray-400" />
          </div>
          <input
            id="union_code"
            name="union_code"
            placeholder="Enter your union code"
            className={`w-full pl-10 pr-4 py-3 rounded-xl  border ${formik.touched.union_code && formik.errors.union_code
              ? 'border-red-500 focus:ring-red-500'
              : 'border-gray-300 focus:ring-indigo-500'
              } focus:outline-none focus:ring-2 transition-colors text-left`}
            {...formik.getFieldProps('union_code')}
          />
        </div>
        {formik.touched.union_code && formik.errors.union_code && (
          <p className="mt-1 text-sm text-left text-red-500">{formik.errors.union_code}</p>
        )}
      </div>

      <div data-aos="fade-up" data-aos-delay="150">
        <div className="flex items-center justify-between mb-2">
          <label htmlFor="password" className="block font-medium text-gray-700">
            Password
          </label>
          <Link to={FORGOT_PASSWORD_ROUTE} className="text-sm text-purple-600 transition-colors hover:text-purple-800">
            Forgot Password?
          </Link>
        </div>
        <div className="relative">
          <div className="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
            <FiLock className="text-gray-400" />
          </div>
          <input
            id="password"
            name="password"
            type={showPassword ? "text" : "password"}
            placeholder="••••••••"
            className={`w-full pl-10 pr-10 py-3 rounded-xl border ${formik.touched.password && formik.errors.password
              ? 'border-red-500 focus:ring-red-500'
              : 'border-gray-300 focus:ring-indigo-500'
              } focus:outline-none focus:ring-2 transition-colors`}
            {...formik.getFieldProps('password')}
          />
          <button
            type="button"
            className="absolute inset-y-0 right-0 flex items-center pr-3"
            onClick={togglePasswordVisibility}
          >
            {showPassword ? <FiEyeOff className="text-gray-400" /> : <FiEye className="text-gray-400" />}
          </button>
        </div>
        {formik.touched.password && formik.errors.password && (
          <p className="mt-1 text-sm text-left text-red-500">{formik.errors.password}</p>
        )}
      </div>

      <div className="flex items-center" data-aos="fade-up" data-aos-delay="200">
        <input
          id="remember-me"
          name="remember-me"
          type="checkbox"
          className="w-4 h-4 text-purple-600 border-gray-300 rounded focus:ring-purple-500"
        />
        <label htmlFor="remember-me" className="block ml-2 text-sm text-gray-700">
          Remember me
        </label>
      </div>

      <button
        type="submit"
        className="w-full cursor-pointer bg-gradient-to-r from-purple-600 to-indigo-700 text-white py-4 rounded-xl font-semibold shadow-lg hover:from-purple-700 hover:to-indigo-800 transition-all transform hover:-translate-y-0.5 focus:outline-none focus:ring-2 focus:ring-purple-500 focus:ring-opacity-50 group"
      >
        <div className="flex items-center justify-center cursor-pointer">
          <span>Sign In</span>
          <div className="ml-2 transition-transform transform cursor-pointer group-hover:translate-x-1">
            <FiCheck />
          </div>
        </div>
      </button>
    </form>
  );
};

export default LoginSignup;